<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t("index.customer")}}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Customer' }">{{$t("index.customerList")}}</el-breadcrumb-item>
          <el-breadcrumb-item>编辑会员</el-breadcrumb-item>
        </el-breadcrumb>
      
    <el-row style="padding: 30px">
      <el-col :span="12">
        <el-form
        size="mini"
          :model="customer"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
        >
          <el-form-item label="昵称" prop="username">
            <el-input v-model="customer.nickname" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item :label="$t('base.mobile')" prop="mobile">
            <el-input v-model="customer.mobile" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="余额" prop="money">
             <el-input-number v-model="customer.money" size="small" :min="0" :step="0.01" ></el-input-number>
          </el-form-item>
           <el-form-item label="折扣" prop="discount">
             <el-input-number v-model="customer.discount" size="small" :min="0.01" :max="1" :step="0.01" ></el-input-number>
          </el-form-item>
            <el-form-item label="订阅会员到期" prop="vip_expire_time">
            <el-date-picker
      v-model="customer.vip_expire_time"
      type="datetime"   value-format="yyyy-MM-dd HH:mm:ss"   placeholder="选择日期时间"      default-time="23:59:59">
    </el-date-picker>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="save()">{{$t("base.save")}}</el-button>
            <el-button @click="back()">{{$t("base.cancel")}}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    var mobileCheck = (tule, value, callback) => {
      if (value && (value.length != 11 || value[0] != 1)) {
        callback(new Error(this.$t('setup.mobileCheck')))
      } else {
        callback()
      }
    }
    return {
      customer: {
      },
      rules: {
        mobile: [
          { required: true, message: this.$t('setup.requireMobile'), trigger: 'blur' },
          { validator: mobileCheck, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
          if(this.$route.params.innerid){
           Vue.axios
        .post('/customer/query', {innerid:this.$route.params.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            this.customer = res.data.msgbody[0]
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
        }
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    save () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          Vue.axios
            .post('/customer/edit',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: self.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t("base.systemError"),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Customer/Edit.vue